import {
  Checkbox,
  CheckboxGroup,
  CheckboxGroupProps,
  Stack,
} from '@chakra-ui/react';

export interface OptionsProps extends Omit<CheckboxGroupProps, 'options'> {
  options: {
    label: string;
    value: string;
  }[];
  stackProps?: {
    [key: string]: string | number;
  };
}

export const Options = ({ options, stackProps, ...props }: OptionsProps) => (
  <CheckboxGroup colorScheme='primary' {...props}>
    <Stack spacing={4} direction='row' wrap='wrap' {...stackProps}>
      {options.map((option) => (
        <Checkbox
          key={option.value}
          borderColor='background.400'
          color='text.900'
          iconColor='text.100'
          value={option.value}
          mr={4}
        >
          {option.label}
        </Checkbox>
      ))}
    </Stack>
  </CheckboxGroup>
);
